import React from "react";

export default function KrogerCsImpact() {
    return (
        <div className="cs-impact-section  section-gap-small">
            <div className="container">
                <div className="cs-impact-content">
                    <h5 className="small-title">The IMPACT</h5>
                    <h3>Real orders and thousands of customers</h3>
                    <p>After the successful MVP, we rolled out the voice assistant in 10+ markets, reaching millions of customers. Within few weeks of launch, the client realized massive growth as the customers started using voice commands and ultimately got an excellent shopping experience.</p>

                    <p>The platform quickly became a strategic enterprise asset with real revenue and recognition from the industry. We can’t wait to see it grow and make a meaningful impact on customers’ lives.</p>
                </div>
            </div>
        </div>
    );
}